import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const PARTNER_CUSTOMERS_QUERY_KEY = ['GET_PARTNER_CUSTOMERS'];

export const useGetPartnerCustomersQuery = () => {
  const { getPartnerCustomers } = useServicesContext();

  return useQuery({
    queryKey: PARTNER_CUSTOMERS_QUERY_KEY,
    queryFn: getPartnerCustomers,
  });
};
